/**
 * テレメータJSON取得
 */
import Repository from "./../JsonRepository";
import logger from "./../../lib/logger";
import Util from "./../../lib/util";

const resource = "";

export default {
  /**
   *  基準値超過観測所取得（都道府県）
   * @param {*} prefCd 都道府県コード
   * @param {*} appTime 取得日時
   */
  getTmOvPref(prefCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getTmOvPref(" + datePath + prefCd + ")");
    return Repository.get(
      `${resource}/overobs/pref/` + datePath + prefCd + ".json"
    );
  },
  /**
   *  基準値超過観測所取得（市町村）
   * @param {*} townCd 市町村コード
   * @param {*} appTime 取得日時
   */
  getTmOvTwn(townCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getTmOvTwn(" + datePath + townCd + ")");
    return Repository.get(
      `${resource}/overobs/twn/` + datePath + townCd + ".json"
    );
  },
  /**
   * 都道府県別超過観測所一覧情報取得
   * @param {*} prefCd 都道府県コード
   * @param {*} appTime 取得日時
   */
  getTmOvDatasPref(prefCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getTmOvDatasPref(" + datePath + prefCd + ")");
    return Repository.get(
      `${resource}/overobs/pref/` + datePath + prefCd + ".json"
    );
  },
  /**
   * 市町村県別超過観測所一覧情報取得
   * @param {*} twnCd 市町村コード
   * @param {*} appTime 取得日時
   */
  getTmOvDatasTwn(twnCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getTmOvDatasTwn(" + datePath + twnCd + ")");
    return Repository.get(
      `${resource}/overobs/twn/` + datePath + twnCd + ".json"
    );
  },
  /**
   * 地点登録の観測所の観測所情報を取得(登録地点情報高アクセス対応)
   * @param {*} ofcCdList 管理事務所番号
   * @param {*} itmkndCdList 観測所種別コード
   * @param {*} obsCdList 観測所コード
   */
  getTmPointIndivInfoData(obsFcdParam) {
    let path =
      "master/obs/" + obsFcdParam.obsKnd + "/" + obsFcdParam.obsFcd + ".json";
    logger.debug("json getTmPointIndivInfoData(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 地点登録の観測所の対象日時観測値を取得(登録地点情報高アクセス対応)
   * @param {*} ofcCdList 管理事務所番号
   * @param {*} itmkndCdList 観測所種別コード
   * @param {*} obsCdList 観測所コード
   */
  getTmPointIndivValueData(obsFcdParam, appTimeRound) {
    let datePath = Util.formatDate(appTimeRound, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path =
      "tmlist/" +
      obsFcdParam.obsKnd +
      "/" +
      datePath +
      obsFcdParam.obsFcd +
      ".json";
    logger.debug("json getTmPointIndivValueData(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 選択中テレメータ観測所情報 取得
   * @param {object} payload
   * @property itmkndCd 観測所種別コード
   * @property obsFcd 伝送記号
   * @property cctvCd 河川カメラID
   * @property ofcCd 管理事務所番号
   * @property scamId 簡易カメラID
   */
  async getSelectedObs(payload) {
    if (payload.itmkndCd == 1) {
      // 観測所種別コード=1(雨量)
      const path = "master/obs/rn/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-rain(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 2) {
      // 観測所種別コード = 2(流域平均雨量)
      const path = "master/obs/bsn/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-bsn(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 3) {
      // 観測所種別コード = 3(積雪)
      const path = "master/obs/snw/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-snow(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 4) {
      // 観測所種別コード = 4(水位)
      const path = "master/obs/stg/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-stage(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 6) {
      // 観測所種別コード = 6(水質)
      const path = "master/obs/qwtr/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-wtr-qual(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 7) {
      // 観測所種別コード = 7(ダム諸量)
      const path = "master/obs/dam/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-dam(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 12) {
      // 観測所種別コード = 12(海岸)
      const path = "master/obs/coast/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-coast(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 20 || payload.itmkndCd == 21) {
      // 観測所種別コード = 20(レーダ流域平均雨量(大流域)) or 21(レーダ流域平均雨量(小流域))
      const path = "master/obs/rdbsn/" + payload.obsFcd + ".json";
      logger.debug("getSelectedObs-rd(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 100) {
      // 観測所種別コード = 100(河川カメラ)
      const path = "master/obs/scam/" + payload.scamId + ".json";
      logger.debug("getSelectedObs-cctv(" + path + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 200) {
      // 観測所種別コード = 200(簡易カメラ)
      const path = "master/obs/scam/" + payload.scamId + ".json";
      logger.debug("getSelectedObs-scam(" + path + ")");
      return Repository.get(`${resource}` + path);
    }
  },
  /**
   * 選択中テレメータ観測値情報 取得
   * @param {object} payload
   * @property itmkndCd 観測所種別コード
   * @property obsFcd 伝送記号
   * @property cctvCd 河川カメラID
   * @property ofcCd 管理事務所番号
   * @property scamId 簡易カメラID
   * @property appTime 対象日時
   */
  async getSelectedTm(payload) {
    let datePath = Util.formatDate(payload.appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    if (payload.itmkndCd == 1) {
      // 観測所種別コード=1(雨量)
      const path = "tmlist/rn/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-rain(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 2) {
      // 観測所種別コード = 2(流域平均雨量)
      const path = "tmlist/bsn/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-bsn(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 3) {
      // 観測所種別コード = 3(積雪)
      const path = "tmlist/snw/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-snow(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 4) {
      // 観測所種別コード = 4(水位)
      const path = "tmlist/stg/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-stage(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 6) {
      // 観測所種別コード = 6(水質)
      const path = "tmlist/qwtr/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-wtr-qual(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 7) {
      // 観測所種別コード = 7(ダム諸量)
      const path = "tmlist/dam/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-dam(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 12) {
      // 観測所種別コード = 12(海岸)
      const path = "tmlist/coast/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-coast(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    } else if (payload.itmkndCd == 20 || payload.itmkndCd == 21) {
      // 観測所種別コード = 20(レーダ流域平均雨量(大流域)) or 21(レーダ流域平均雨量(小流域))
      const path = "tmlist/rdbsn/" + datePath + payload.obsFcd + ".json";
      logger.debug("getSelectedTm-rd(" + payload.obsFcd + ")");
      return Repository.get(`${resource}` + path);
    }
  },
  /**
   * 統一河川コード取得
   * @param rvrCd 国交省河川コード
   */
  getConvRvrCd(rvrCd) {
    // 観測所種別コード=1(雨量)
    const path = "master/conv/" + rvrCd + ".json";
    logger.debug("getConvRvrCd(" + rvrCd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 簡易カメラ日時取得
   * @param url 最新画像時刻情報ファイル提供URL
   */
  getScamDetailJson(url) {
    logger.debug("getScamDetailJson(" + url + ")");
    return Repository.get(url);
  },
   /**
   * 過去簡易カメラ日時取得
   * @param url 最新画像時刻情報ファイル提供URL
   */
  getHistoryScamDetailJson(url) {
    logger.debug("getHistoryScamDetailJson(" + url + ")");
    return Repository.get(url);
  }
};
